import { useAuth } from "@/core/hooks/useAuth";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import log from "loglevel";
import { useState } from "react";

export type ForgotPasswordForm = {
  email: string;
};

export const useForgotPasswordController = () => {
  const { forgotPassword } = useAuth();

  const [loading, { open: openLoading, close: closeLoading }] =
    useDisclosure(false);

  const [emailSent, setEmailSent] = useState(false);

  const form = useForm<ForgotPasswordForm>({
    initialValues: {
      email: "",
    },
    validateInputOnBlur: true,

    validate: {
      email: (value) => {
        const cleanedValue = value.trim();
        if (!cleanedValue) {
          return "E-mail é obrigatório";
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(cleanedValue) ? null : "E-mail inválido";
      },
    },
  });

  const handleForgotPassword = async () => {
    openLoading();
    try {
      await forgotPassword(form.values.email.trim());
      setEmailSent(true);

      setTimeout(() => {
        notifications.show({
          title: "Redefinição de senha solicitada",
          message: "Verifique seu e-mail!",
          color: "teal",
          autoClose: 3000,
        });
      }, 100);

      form.reset();
    } catch (error) {
      log.error(error);
      notifications.show({
        title: "Erro na solicitação de redefinição de senha",
        message: "Tente novamente em instantes.",
        color: "red",
        autoClose: 4000,
      });
    } finally {
      closeLoading();
    }
  };

  return {
    form,
    loading,
    emailSent,
    handleForgotPassword,
  };
};
